import React from 'react';
import { ArcOutlinedInput } from '@src/core/ui';
import { IEmailInputProps } from './types';

const EmailInput: React.FC<IEmailInputProps> = ({ register, error, autoComplete = 'off' }) => {
  return (
    <ArcOutlinedInput
      fullWidth
      label='Email'
      autoComplete={autoComplete}
      error={Boolean(error)}
      helperText={error?.message}
      {...register}
    />
  );
};

export default EmailInput;

